export default "__VITE_ASSET__DefivsGY__"